import React from "react";
import hero1 from "../../images/hero/1_new.jpg";
// import hero1 from "../../images/hero/1.jpeg";
import shape from "../../images/hero/flower.png";

const Hero: React.FC = () => {
  return (
    <section className="wpo-hero-static">
      <div className="content">
        <h2 className="splittext-line">Nuestra</h2>
        <h2 className="text-bottom splittext-line">Boda</h2>

        <div className="hero-description wow fadeInUp" data-wow-delay="0.2s">
          <p>
            Bienvenidos a nuestra historia. El <span>27 de junio de 2026.</span>  Estamos muy felices de poder compartir este momento tan especial con ustedes.
            Gracias por acompañarnos en el inicio de esta nueva etapa juntos.
          </p>
          <br />
          <p> Ve la cuenta regresiva dando click </p>
            <a href="Coming" className="btn">
              <b>¡Aquí!</b>
            </a>
        </div>

        <div className="hero-circle wow fadeInUp" data-wow-delay="0.2s">
          <div className="circle-content">
            <div className="rotate-anm">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <path
                    id="circle1"
                    d="
                      M 50, 50
                      m -37, 0
                      a 37,37 0 1,1 74,0
                      a 37,37 0 1,1 -74,0
                    "
                  />
                </defs>
                <text>
                  <textPath href="#circle1">you are invited</textPath>
                </text>
              </svg>
              <div className="flower">
                <img src={shape} alt="Flower Shape" />
              </div>
            </div>
            <div className="circle-big"></div>
            <div className="circle-small"></div>
          </div>
        </div>
      </div>

      <div
        className="hero-right wow fadeInRightSlow"
        data-wow-duration="1000ms"
      >
        <img src={hero1} alt="Wedding Hero" />
      </div>
    </section>
  );
};

export default Hero;
